// @ts-nocheck
import React, { useEffect, useState } from 'react';
import euforms from "../../images/euforms.png";
import {
    ClipboardDocumentIcon,
    CheckIcon
} from '@heroicons/react/24/outline';
import { useI18n } from '../../i18n/I18nContext';

const Multibanco = ({ paymentinfo }) => {

    const { language, t } = useI18n();

    const showDates =
        paymentinfo.mbStartDate &&
        paymentinfo.mbEndDate;

    const [copied, setCopied] =
        useState(false);

    const locale =
        language === 'PT'
            ? 'pt-PT'
            : language === 'ES'
                ? 'es-ES'
                : 'en-GB';


    const formatDate = (value) =>
        new Intl.DateTimeFormat(
            locale
        ).format(
            new Date(value)
        );


    const formatAmount = (value) =>
        new Intl.NumberFormat(
            locale,
            {
                style: 'currency',
                currency: 'EUR'
            }
        ).format(
            Number(value) || 0
        );


    useEffect(() => {

        if (!copied) {
            return;
        }

        const timeoutId =
            window.setTimeout(
                () => setCopied(false),
                2500
            );

        return () =>
            window.clearTimeout(
                timeoutId
            );

    }, [copied]);


    const copyPaymentDetails = async () => {

        const details = [

            t('Pagamento Multibanco'),

            `${t('Entidade')}: ${paymentinfo.entity}`,

            `${t('Referência')}: ${paymentinfo.reference}`,

            `${t('Valor')}: ${formatAmount(paymentinfo.value)}`,

            showDates
                ? `${t('Data limite')}: ${formatDate(paymentinfo.mbEndDate)}`
                : null

        ]
            .filter(Boolean)
            .join('\n');


        await navigator.clipboard.writeText(
            details
        );

        setCopied(true);
    };


    return (

        <div className="overflow-x-hidden">

            <nav className="flex items-center justify-between flex-wrap bg-green-cl p-6">

                <div className="flex items-center flex-shrink-0 text-white mr-6">

                    <img
                        className="h-8"
                        src={euforms}
                        alt="Logo"
                    />

                </div>

            </nav>


            <div className="mt-20 flex flex-col items-center justify-center bg-gray-100">

                <div className="bg-white shadow-md rounded-lg p-12 w-full max-w-4xl">

                    <h1 className="text-4xl font-bold text-green-600 text-center mb-10">
                        Formulário preenchido com sucesso!
                    </h1>


                    <p className="text-gray-600 text-center mb-5 text-lg">

                        O seu formulário foi processado com sucesso.
                        Abaixo pode ver os seus detalhes de pagamento:

                    </p>


                    <div className="overflow-x-auto">

                        <table className="w-full border-collapse">

                            <thead className="bg-gray-200">

                            <tr>

                                <th className="py-4 px-6 border text-lg">
                                    Método
                                </th>

                                <th className="py-4 px-6 border text-lg">
                                    Referência
                                </th>

                                <th className="py-4 px-6 border text-lg">
                                    Entidade
                                </th>


                                {
                                    showDates && (
                                        <>

                                            <th className="py-4 px-6 border text-lg">
                                                Data inicial
                                            </th>

                                            <th className="py-4 px-6 border text-lg">
                                                Data limite
                                            </th>

                                        </>
                                    )
                                }


                                <th className="py-4 px-6 border text-lg">
                                    Valor
                                </th>

                            </tr>

                            </thead>


                            <tbody className="divide-y">

                            <tr className="text-center">

                                <td className="py-6 px-6 border">

                                    <div className="flex justify-center">

                                        <div className="payment-logo-surface inline-flex items-center justify-center rounded-xl px-4 py-3 shadow-sm">

                                            <img
                                                className="w-16 object-contain"
                                                src="/payment-icons/multibanco.webp"
                                                alt="Multibanco"
                                            />

                                        </div>

                                    </div>

                                </td>


                                <td className="py-6 px-6 border text-lg">
                                    {paymentinfo.reference}
                                </td>


                                <td className="py-6 px-6 border text-lg">
                                    {paymentinfo.entity}
                                </td>


                                {
                                    showDates && (
                                        <>

                                            <td className="py-6 px-6 border text-lg">

                                                {formatDate(
                                                    paymentinfo.mbStartDate
                                                )}

                                            </td>

                                            <td className="py-6 px-6 border text-lg">

                                                {formatDate(
                                                    paymentinfo.mbEndDate
                                                )}

                                            </td>

                                        </>
                                    )
                                }


                                <td className="py-6 px-6 border text-lg">

                                    {formatAmount(
                                        paymentinfo.value
                                    )}

                                </td>

                            </tr>

                            </tbody>

                        </table>

                    </div>


                    <div className="mt-6 flex justify-center">

                        <button
                            type="button"
                            onClick={copyPaymentDetails}
                            className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-5 py-3 font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
                        >

                            {
                                copied
                                    ? (
                                        <CheckIcon className="h-5 w-5 text-emerald-600" />
                                    )
                                    : (
                                        <ClipboardDocumentIcon className="h-5 w-5" />
                                    )
                            }


                            {
                                copied
                                    ? t('Dados copiados')
                                    : t('Copiar dados de pagamento')
                            }

                        </button>

                    </div>


                    {/* Secção de Donativos */}
                    {
                        paymentinfo.donations &&
                        Object.keys(paymentinfo.donations).length > 0 && (

                            <div className="mt-10">

                                <h2 className="text-2xl font-semibold text-center text-green-600 mb-4">
                                    Donativos
                                </h2>


                                <table className="w-full border-collapse">

                                    <thead className="bg-gray-100">

                                    <tr>

                                        <th className="py-3 px-4 border text-left">
                                            Elemento
                                        </th>

                                        <th className="py-3 px-4 border text-left">
                                            Valor doado
                                        </th>

                                    </tr>

                                    </thead>


                                    <tbody className="divide-y">

                                    {
                                        Object.entries(
                                            paymentinfo.donations
                                        ).map(
                                            ([elementId, amount]) => (

                                                <tr key={elementId}>

                                                    <td className="py-3 px-4 border">
                                                        {elementId}
                                                    </td>

                                                    <td className="py-3 px-4 border">

                                                        {formatAmount(
                                                            amount
                                                        )}

                                                    </td>

                                                </tr>
                                            )
                                        )
                                    }

                                    </tbody>

                                </table>

                            </div>
                        )
                    }

                </div>

            </div>

        </div>
    );
};


export default Multibanco;